type SelectValueProps = {
  label: string;
  value: string;
  onDelete: (value: string) => void;
};

export const SelectValue = ({ label, value, onDelete }: SelectValueProps) => (
  <div className="bg-grayScale-100 text-ui12 flex items-center justify-between rounded-md p-2">
    <span>{label}</span>
    <button
      onClick={(e) => {
        e.stopPropagation();
        onDelete(value);
      }}
      className=" ml-2 cursor-pointer"
    >
      x
    </button>
  </div>
);
